import {
	FETCH,
	POST,
	ERROR,
	GOT_RESPONSE,
	ME,
	CREATE_TOUR,
	GET_TOURS,
	ADMIN_GET_TOURS,
	ADMIN_GET_USERS,
	ADMIN_GET_TOURGUIDES,
	GET_MYTOUR,
	GET_LOCATIONS,
	EDIT_TOURGUIDE,
	CREATE_TOURGUIDE,
	EDIT_TOUR,
	GET_MY_TOURGUIDE_PROFILE,
	GET_PRESIGNED_IMAGE_URLS,
	GET_LOCATION_VIEW,
	UPLOAD_FILE_TO_S3,
	PUT,
	DELETE,
	DELETE_TOUR,
	CLEAR_MYTOUR,
	CLEAR_ME,
	GET_TOUR,
	LOCAL_EDIT_TOURGUIDE,
	CLEAR_PRESIGNED_IMAGE_URLS,
	GET_TOUR_EVENTS,
	CREATE_TOUR_EVENT,
	DELETE_TOUR_EVENT,
	GET_PUBLIC_TOUR_EVENTS,
	CREATE_BOOKING,
	CLEAR_PUBLIC_TOUR_EVENTS,
	SEARCH_TOURS,
	CLEAR_SEARCH_RESULTS,
	GET_TOUR_TRACKS,
	CREATE_AUDIO_TRACK,
	UPDATE_AUDIO_TRACK,
	DELETE_AUDIO_TRACK,
	GET_AUDIO_PRESIGNED_URL,
	CLEAR_AUDIO_PRESIGNED_URL,
	GET_TOUR_SHARES,
	CREATE_TOUR_SHARE,
	DELETE_TOUR_SHARE,
	CLEAR_TOUR_SHARES,
} from './constants';

const initState = {
	loading: false,
	me: null,
	categories: [],
	recipes: [],
	error: null,
	tours: [],
	adminTours: [],
	adminUsers: [],
	adminTourGuides: [],
	tour: null,
	myTour: null,
	tourguide: null,
	message: null,
	locations: [],
	locationView: [],
	presignedImageUrls: [],
	tourEvents: [],
	publicTourEvents: [],
	lastBooking: null,
	searchResults: null,
	tourTracks: [],
	audioPresignedUrl: null,
	tourShares: null,
}

const API = (state = initState, action) => {
	switch (action.type) {
		case FETCH:
		case POST:
		case PUT:
		case DELETE:
			return { ...state, loading: true, error: null, message: null }
		case UPLOAD_FILE_TO_S3:
			return { ...state, loading: true, error: null, message: null }
		case CLEAR_MYTOUR:
			return { ...state, myTour: null }
			case CLEAR_ME:
				return { ...state, me: null }
			case CLEAR_AUDIO_PRESIGNED_URL:
				return { ...state, audioPresignedUrl: null }
			case CLEAR_TOUR_SHARES:
				return { ...state, tourShares: null }
			case GOT_RESPONSE:
			if (action.responseType === ME) {
				return { ...state, loading: false, error: null, me: action.response }
			} else if (action.responseType === CREATE_TOUR) {
				return { ...state, loading: false, error: null, myTour: action.response, message: "Tour Created", presignedImageUrls: [] }
			} else if (action.responseType === EDIT_TOUR) {
				return { ...state, loading: false, error: null, myTour: action.response, message: "Tour Updated", presignedImageUrls: [] }
			} else if (action.responseType === GET_MYTOUR) {
				return { ...state, loading: false, error: null, myTour: action.response }
			} else if (action.responseType === GET_TOURS) {
				return { ...state, loading: false, error: null, tours: action.response.tours }
			} else if (action.responseType === ADMIN_GET_TOURS) {
				return { ...state, loading: false, error: null, adminTours: action.response.tours || [] }
			} else if (action.responseType === ADMIN_GET_USERS) {
				const users = Array.isArray(action.response)
					? action.response
					: (action.response?.users || []);
				return { ...state, loading: false, error: null, adminUsers: users }
			} else if (action.responseType === ADMIN_GET_TOURGUIDES) {
				const tourguides = Array.isArray(action.response)
					? action.response
					: (action.response?.tourguides || []);
				return { ...state, loading: false, error: null, adminTourGuides: tourguides }
			} else if (action.responseType === GET_LOCATIONS) {
				return { ...state, loading: false, error: null, locations: action.response.locations }
			} else if (action.responseType === EDIT_TOURGUIDE || action.responseType === CREATE_TOURGUIDE) {
				return { ...state, loading: false, error: null, tourguide: action.response, message: "Tourguide Updated" }
			} else if (action.responseType === GET_MY_TOURGUIDE_PROFILE) {
				return { ...state, loading: false, error: null, tourguide: action.response }
			} else if (action.responseType === DELETE_TOUR) {
				return { ...state, loading: false, error: null, message: "Tour Deleted", myTour: null }
			} else if (action.responseType === GET_PRESIGNED_IMAGE_URLS) {
				return { ...state, loading: false, error: null, presignedImageUrls: action.response.presigned_urls }
			} else if (action.responseType === UPLOAD_FILE_TO_S3) {
				return { ...state, loading: false, error: null, message: "Image Uploaded" }
			} else if (action.responseType === GET_LOCATION_VIEW) {
				return { ...state, loading: false, error: null, locationView: action.response.locations }
			} else if (action.responseType === GET_TOUR) {
				return { ...state, loading: false, error: null, tour: action.response }
			} else if (action.responseType === GET_TOUR_EVENTS) {
				return { ...state, loading: false, error: null, tourEvents: action.response.events || [] }
			} else if (action.responseType === CREATE_TOUR_EVENT) {
				return { ...state, loading: false, error: null, tourEvents: [...state.tourEvents, action.response], message: "Date Added" }
			} else if (action.responseType === DELETE_TOUR_EVENT) {
				return { ...state, loading: false, error: null, message: "Date Removed" }
			} else if (action.responseType === GET_PUBLIC_TOUR_EVENTS) {
				return { ...state, loading: false, error: null, publicTourEvents: action.response.events || [] }
			} else if (action.responseType === CREATE_BOOKING) {
				return {
					...state,
					loading: false,
					error: null,
					lastBooking: action.response.booking,
					message: action.response.message || "Booking confirmed!"
				}
			} else if (action.responseType === SEARCH_TOURS) {
				return {
					...state,
					loading: false,
					error: null,
					searchResults: action.response
				}
			} else if (action.responseType === GET_TOUR_TRACKS) {
				return { ...state, loading: false, error: null, tourTracks: action.response }
			} else if (action.responseType === GET_AUDIO_PRESIGNED_URL) {
				return { ...state, loading: false, error: null, audioPresignedUrl: action.response }
			} else if (action.responseType === CREATE_AUDIO_TRACK) {
				return {
					...state,
					loading: false,
					error: null,
					message: "Stop Created",
					audioPresignedUrl: null,
					tourTracks: [...state.tourTracks, action.response],
				}
			} else if (action.responseType === UPDATE_AUDIO_TRACK) {
				return {
					...state,
					loading: false,
					error: null,
					message: "Stop Updated",
					tourTracks: state.tourTracks.map((track) => (
						track.id === action.response.id ? action.response : track
					)),
				}
			} else if (action.responseType === DELETE_AUDIO_TRACK) {
				return { ...state, loading: false, error: null, message: "Stop Deleted" }
			} else if (action.responseType === GET_TOUR_SHARES) {
				return { ...state, loading: false, error: null, tourShares: action.response }
			} else if (action.responseType === CREATE_TOUR_SHARE) {
				const currentShares = state.tourShares?.shares || [];
				return {
					...state,
					loading: false,
					error: null,
					message: "Tour Shared",
					tourShares: {
						shares: [...currentShares, action.response],
						total: currentShares.length + 1,
					},
				}
			} else if (action.responseType === DELETE_TOUR_SHARE) {
				return { ...state, loading: false, error: null, message: "Share Removed" }
			}
			return { ...state, loading: false, error: `Unimplemented Error: ${action}` }
		case CLEAR_SEARCH_RESULTS:
			return { ...state, searchResults: null }
		case CLEAR_PUBLIC_TOUR_EVENTS:
			return { ...state, publicTourEvents: [] }
		case LOCAL_EDIT_TOURGUIDE:
			return { ...state, loading: false, error: null, tourguide: action.tourguide }
		case CLEAR_PRESIGNED_IMAGE_URLS:
			return { ...state, presignedImageUrls: [] }
		case ERROR:
			return { ...state, loading: false, error: action.error }
		default:
			return state;

	}
};

export default API;
